import { isEmpty } from 'lodash';
import { getCurrentApiHost } from 'config/environment';
import { CustomerPreview } from 'services';
import { TimerApi } from 'services/timer';
export var InitWorkerRequestType = /*#__PURE__*/ function(InitWorkerRequestType) {
    InitWorkerRequestType["GetMeta"] = "GET_META";
    InitWorkerRequestType["Init"] = "INIT";
    InitWorkerRequestType["TaskFields"] = "TASK_FIELDS";
    InitWorkerRequestType["Fields"] = "FIELDS";
    InitWorkerRequestType["Members"] = "MEMBERS";
    InitWorkerRequestType["RmConfig"] = "RM_CONFIG";
    InitWorkerRequestType["TimesheetConifg"] = "TS_CONFIG";
    InitWorkerRequestType["ProjectPageMembers"] = "PROJECT_PAGE_MEMBERS";
    InitWorkerRequestType["AccountConfig"] = "ACCOUNT_CONFIG";
    InitWorkerRequestType["PermissionSetDefinitions"] = "PERMISSION_SET_DEFINITIONS";
    return InitWorkerRequestType;
}({});
// this is used so that when refetching data from the api, it should return new values
const invalidateKey = {
    ["FIELDS"]: false,
    ["TASK_FIELDS"]: false,
    ["GET_META"]: false,
    ["INIT"]: false,
    ["MEMBERS"]: false,
    ["PROJECT_PAGE_MEMBERS"]: false,
    ["RM_CONFIG"]: false,
    ["TS_CONFIG"]: false,
    ["ACCOUNT_CONFIG"]: false,
    ["PERMISSION_SET_DEFINITIONS"]: false
};
const apiPathMap = {
    ["GET_META"]: '/api/v1/accounts/get-meta',
    ["INIT"]: '/api/v1/home/init',
    ["ACCOUNT_CONFIG"]: '/api/v1/home/configuration',
    ["TASK_FIELDS"]: '/api/v1/fields/task',
    ["FIELDS"]: '/api/v1/fields',
    ["MEMBERS"]: '/api/v1/members',
    ["RM_CONFIG"]: '/api/v1/resource-management/config',
    ["TS_CONFIG"]: '/api/v1/timesheets/config',
    ["PROJECT_PAGE_MEMBERS"]: '/api/v1/members',
    ["PERMISSION_SET_DEFINITIONS"]: '/api/v1/permission-set/get-definition'
};
const getData = async (key)=>{
    // In test environment, make the HTTP call directly instead of using the web worker
    if (process.env.NODE_ENV === 'test') {
        const apiKey = localStorage.getItem('__api_key');
        const headers = {};
        if (apiKey) {
            const [, apiKeyValue] = JSON.parse(apiKey);
            headers['api-key'] = apiKeyValue;
        }
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        const resp = await fetch(`${API_HOST}${apiPathMap[key]}`, {
            headers
        });
        return resp.json();
    }
    const [isPreview] = await CustomerPreview.isPreviewMode();
    return new Promise((resolve, rej)=>{
        const isInvalidate = invalidateKey[key];
        const timer = new TimerApi(30000);
        if (window.initWorker == null) {
            throw new Error('Worker is not available');
        }
        window.initWorker.postMessage({
            type: 'getData',
            request: key,
            isInvalidate,
            isCustomerPreview: window.location.search.includes('customer-preview=true') || isPreview,
            data: {
                apiKey: localStorage.getItem('__api_key') != null ? JSON.parse(localStorage.getItem('__api_key'))[1] : undefined,
                domain: `${getCurrentApiHost()}/api`
            }
        });
        timer.start();
        timer.onElapsed(()=>{
            rej();
        });
        window.initWorker.addEventListener('message', (e)=>{
            if (e.data.type === key && e.data.respData === 'ERROR_OCCURRED') {
                timer.stop();
                rej();
            } else if (e.data.type === key && !isEmpty(e.data.respData)) {
                timer.stop();
                resolve(JSON.parse(e.data.respData));
            // this is removed so that when refetching data from the worker should return same values
            // invalidateKey[key] = true;
            }
        });
    });
};
const setData = async ()=>{
    if (window.initWorker == null) {
        return;
    }
    const isApiKeyPresent = localStorage.getItem('__api_key') != null;
    const [isPreview] = await CustomerPreview.isPreviewMode();
    window.initWorker.addEventListener('message', ()=>{
        window.initWorker.postMessage({
            type: isApiKeyPresent ? 'setData' : 'setMetaData',
            isInvalidate: false,
            isCustomerPreview: window.location.search.includes('customer-preview=true') || isPreview,
            data: {
                apiKey: isApiKeyPresent ? JSON.parse(localStorage.getItem('__api_key'))[1] : undefined,
                domain: `${getCurrentApiHost()}/api`
            }
        });
    });
};
export const InitWorkerApi = {
    getData,
    setData
};
